import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import { useImages } from '../context/ImageContext';

const CompareAlert1ToGreatCallPage: React.FC = () => {
  const { getImage } = useImages();
  const heroImage = getImage('compare-alert1-great-call-mobile-medical-alert-pendant.jpg');
  
  // Reason icons
  const savingsIcon = getImage('compare-alert1-savings-icon.jpg');
  const responseIcon = getImage('compare-alert1-response-icon.jpg');
  const buttonPushIcon = getImage('compare-alert1-button-push-icon.jpg');
  const monthlyPlanIcon = getImage('compare-alert1-monthly-plan-icon.jpg');
  const helpIcon = getImage('compare-alert1-help-icon.jpg');
  const grandfatherImage = getImage('5-grandfather-grandson.jpg');
  const readyToTryImage = getImage('6-Price-Compare-Mobile-Medical-Alert.jpg');

  return (
    <div className="compare-alert1-to-greatcall-page compare-alert1-to-life-alert-page">
      {/* Hero Section */}
      <section className="compare-hero-new">
        <div className="compare-hero-container">
          <div className="compare-hero-content">
            <h1>The Perfect GreatCall Alternative for Senior Safety Services</h1>
            
            <p className="compare-hero-text">
              Alert1 offers premium medical alert services with advantages over GreatCall's Lively Mobile, including affordable, flexible payment plans, mobile on-the-go and in-home medical alert coverage, and voice command capabilities for calls and texts.
            </p>
            
            <p className="compare-hero-text">
              Compare our features with GreatCall in the comparison chart¹—you'll find similar or better features at competitive prices.
            </p>
            
            <p className="compare-hero-text">
              For protection and peace of mind, call 1-877-573-4195 today.
            </p>
            
            <div style={{ textAlign: 'center', marginTop: '2rem' }}>
              <Link to="/medical-alerts" className="btn btn-primary compare-hero-btn">
                VIEW SYSTEMS
              </Link>
            </div>
          </div>
          
          <div className="compare-hero-image">
            <div className="circular-image-wrapper">
              {heroImage ? (
                <img 
                  src={heroImage} 
                  alt="Elderly woman and young boy" 
                  className="circular-image"
                />
              ) : (
                <div className="circular-image-placeholder" />
              )}
            </div>
            <div style={{ textAlign: 'center', marginTop: '1.5rem' }}>
              <p style={{ fontSize: '1rem', color: '#333', margin: '0.5rem 0', lineHeight: '1.5' }}>
                Call <strong>1-877-573-4195</strong> today and
              </p>
              <p style={{ fontSize: '1rem', color: '#333', margin: '0.5rem 0', lineHeight: '1.5' }}>
                see why Alert1 is the best
              </p>
              <p style={{ fontSize: '1rem', color: '#333', margin: '0.5rem 0', lineHeight: '1.5' }}>
                medical alert system provider for
              </p>
              <p style={{ fontSize: '1rem', color: '#333', margin: '0.5rem 0', lineHeight: '1.5' }}>
                you or your loved one.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Company Descriptions Section */}
      <section className="comparison-section">
        <div className="container">
          <p style={{ fontSize: '0.9rem', lineHeight: '1.3', color: '#333', marginBottom: '1rem', maxWidth: '1200px', margin: '0 auto 1rem auto' }}>
            GreatCall is a San Diego California based medical alert company, acquired by Best Buy in 2018 for $792 million. It provides mobile products and medical alert systems for seniors. Its Jitterbug phone and Lively emergency devices offer one-touch access to trained agents for caregiver connections, concierge services, and emergency response. As part of Best Buy Health, GreatCall enhances senior independence with easy-to-use technology and comprehensive support.
          </p>
          
          <p style={{ fontSize: '0.9rem', lineHeight: '1.3', color: '#333', marginBottom: '2rem', maxWidth: '1200px', margin: '0 auto 2rem auto' }}>
            Alert1 is a Williamsport, Pennsylvania based senior safety company with some of the most affordable medical alert devices for seniors. Alert1 offers affordable medical alert devices with the ability to confirm your location and situation in emergencies. Users receive 24/7 support through both traditional alert systems and community-connected smartphone options. Our trained agents respond quickly to confirm your needs and ability to communicate during emergencies.
          </p>
          
          <div className="comparison-table-wrapper">
            <table className="comparison-table">
              <thead>
                <tr>
                  <th></th>
                  <th className="highlight-col">Alert1</th>
                  <th>GreatCall</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <strong>Prices Starting At</strong>
                    <br />
                    <Link to="/pricing" style={{ fontSize: '0.9rem', color: '#0066cc', textDecoration: 'underline' }}>See Pricing</Link>
                  </td>
                  <td className="highlight-col">$19.95/mo<sup>1</sup></td>
                  <td>$49.99/mo<sup>2</sup></td>
                </tr>
                <tr>
                  <td><strong>No Long-Term Contract Required</strong></td>
                  <td className="highlight-col">✓</td>
                  <td>✓</td>
                </tr>
                <tr>
                  <td><strong>Nationwide Coverage</strong></td>
                  <td className="highlight-col">✓</td>
                  <td>✓</td>
                </tr>
                <tr>
                  <td><strong>UL Listed</strong><br /><small>Monitoring center</small></td>
                  <td className="highlight-col">✓</td>
                  <td>Not Listed</td>
                </tr>
                <tr>
                  <td><strong>BBB Accredited Business</strong><br /><small>A+ rating from the Better Business Bureau</small></td>
                  <td className="highlight-col">✓</td>
                  <td>Unknown</td>
                </tr>
                <tr>
                  <td><strong>Constant Care</strong><br /><small>We stay on the phone until help arrives</small></td>
                  <td className="highlight-col">✓</td>
                  <td>✓</td>
                </tr>
                <tr>
                  <td><strong>Multilingual Protection</strong><br /><small>Responders speak 190 different languages</small></td>
                  <td className="highlight-col">✓</td>
                  <td></td>
                </tr>
                <tr>
                  <td><strong>Same Day Shipping</strong><br /><small>For 85% or more of orders</small></td>
                  <td className="highlight-col">✓</td>
                  <td></td>
                </tr>
                <tr>
                  <td><strong>Unlimited Button Pushes</strong><br /><small>Never charges for pushing your button</small></td>
                  <td className="highlight-col">✓</td>
                  <td></td>
                </tr>
                <tr>
                  <td><strong>Thayer Certified</strong><br /><small>Safe, fair working environment</small></td>
                  <td className="highlight-col">✓</td>
                  <td></td>
                </tr>
                <tr>
                  <td><strong>TMA 5 Diamond Certified Command Center</strong><br /><small>Ensures that each center meets only the highest standards</small></td>
                  <td className="highlight-col">✓</td>
                  <td>Not Listed</td>
                </tr>
                <tr>
                  <td><strong>Modern Senior Magazine<sup>*</sup></strong><br /><small>#1 Rated Medical Alert System</small></td>
                  <td className="highlight-col">✓</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* 5 Reasons Section */}
      <section className="reasons-section" style={{ background: 'white' }}>
        <div className="container">
          <h2>5 Reasons Why Alert1 is the Best GreatCall / Lively Mobile Alternative</h2>
          
          <div className="reasons-list">
            <div className="reason-item">
              <div className="reason-icon">
                {savingsIcon && (
                  <img src={savingsIcon} alt="Value" />
                )}
              </div>
              <div className="reason-content">
                <h4><span className="reason-number">1.</span> Value</h4>
                <p>
                  We have systems to meet every need, lifestyle, and budget (invaluable protection at affordable pricing)
                </p>
              </div>
            </div>

            <div className="reason-item">
              <div className="reason-icon">
                {responseIcon && (
                  <img src={responseIcon} alt="Support" />
                )}
              </div>
              <div className="reason-content">
                <h4><span className="reason-number">2.</span> Support</h4>
                <p>
                  Once a member sends an alert, our emergency response team stays on the line with them until help 
                  arrives (not all companies do this)
                </p>
              </div>
            </div>

            <div className="reason-item">
              <div className="reason-icon">
                {buttonPushIcon && (
                  <img src={buttonPushIcon} alt="Transparency" />
                )}
              </div>
              <div className="reason-content">
                <h4><span className="reason-number">3.</span> Transparency</h4>
                <p>
                  Alert1 does not charge our members for "false alarms" or multiple emergency button-pushes 
                  (some other companies do)
                </p>
              </div>
            </div>

            <div className="reason-item">
              <div className="reason-icon">
                {monthlyPlanIcon && (
                  <img src={monthlyPlanIcon} alt="Flexibility" />
                )}
              </div>
              <div className="reason-content">
                <h4><span className="reason-number">4.</span> Flexibility</h4>
                <p>
                  We provide monthly service plan options so no one is "locked in," as well as discounted annual plans 
                  (some of our competitors only offer multi-year plans)
                </p>
              </div>
            </div>

            <div className="reason-item">
              <div className="reason-icon">
                {helpIcon && (
                  <img src={helpIcon} alt="Service" />
                )}
              </div>
              <div className="reason-content">
                <h4><span className="reason-number">5.</span> Service</h4>
                <p>
                  Our emergency Command Centers are staffed by trained agents who are available 24/7/365 
                  (professional responders are always standing by)
                </p>
              </div>
            </div>
          </div>

          <div className="cta-center">
            <Link to="/medical-alerts" className="btn btn-primary">TRY US TODAY</Link>
          </div>
        </div>
      </section>

      {/* Why Choose Alert1 Section */}
      <section className="alternative-section" style={{ background: 'white' }}>
        <div className="container">
          <div className="value-content-wrapper">
            <div className="value-image">
              <div className="circular-image-wrapper">
                {grandfatherImage ? (
                  <img 
                    src={grandfatherImage} 
                    alt="Grandfather and grandson fishing" 
                    className="circular-image"
                  />
                ) : (
                  <div className="circular-image-placeholder" />
                )}
              </div>
            </div>
            
            <h2>Why Choose Alert1 Medical Alert Systems?</h2>
            
            <ul style={{ listStyle: 'disc', paddingLeft: '2rem', lineHeight: '1.8', fontSize: '1.15rem', maxWidth: '900px' }}>
              <li><strong>Continuous Support:</strong> Agents stay on the line until help arrives.</li>
              <li><strong>Comfortable Design:</strong> Lightweight, discreet pendants or wristbands for men and women.</li>
              <li><strong>100% Showerproof:</strong> Wearable in the bath or wet weather.</li>
              <li><strong>Great audio:</strong> No need to project your voice unnaturally.</li>
              <li><strong>Simple Setup:</strong> Pre-programmed systems, just plug in and go.</li>
              <li><strong>Instant Response:</strong> One click to connect with trained operators.</li>
              <li><strong>Extensive Coverage:</strong> 600 ft. in-home range; unlimited mobile range across USA.</li>
              <li><strong>No Usage Penalties:</strong> Press the button as often as needed without extra fees.</li>
              <li><strong>Enhanced Safety:</strong> Optional fall detection and GPS technology.</li>
              <li><strong>Flexible Payment:</strong> Monthly or discounted advance payment plans.</li>
              <li><strong>Practical Utility:</strong> Helpful for seniors needing assistance with close-up tasks like reading.</li>
            </ul>
          </div>
          
          <div style={{ marginTop: '2rem', clear: 'both', maxWidth: '900px' }}>
            <p className="section-intro" style={{ marginBottom: '2rem', textAlign: 'left' }}>
              In addition to securing assistance fast in the event of a frightening or disorienting medical emergency, you can also use your Alert1 medical alert device to contact a Circle of Care (pre-provided contacts), giving you options and control. Our systems are also useful when you need to get in touch with a friend or family member for assistance and you don't want to call 911.
            </p>
          </div>
          
          <div className="cta-center">
            <Link to="/medical-alerts" className="btn btn-primary">VIEW SYSTEMS</Link>
          </div>
        </div>
      </section>

      {/* Ready to Try Alert1 Section */}
      <section className="alternative-section" style={{ background: '#f9f9f9' }}>
        <div className="container">
          <h2>Isn't it Time to Try Alert1 Medical Alert Systems?</h2>
          
          <div style={{ display: 'flex', gap: '3rem', marginTop: '3rem', alignItems: 'flex-start' }}>
            <div style={{ flexShrink: 0 }}>
              <div className="circular-image-wrapper" style={{ width: '300px', height: '300px' }}>
                {readyToTryImage ? (
                  <img 
                    src={readyToTryImage} 
                    alt="Mobile medical alert" 
                    className="circular-image"
                  />
                ) : (
                  <div className="circular-image-placeholder" />
                )}
              </div>
            </div>
            
            <div style={{ flex: 1 }}>
              <p className="section-intro">
                We invite you or your loved one to be our next valued member! The choice is yours—you can either order your new medical alarm service{' '}
                <Link to="/medical-alerts" style={{ fontWeight: 'bold', textDecoration: 'underline', color: '#333' }}>right here</Link>
                {' '}on our website, or call one of our New Member Specialists who will be happy to answer any questions and get you started. It's time to enjoy the security, protection, and peace of mind you'll get from your new personal alarm button.
              </p>
              
              <p className="section-intro">
                As an added bonus, Alert1 will ship your new medical alert system using FedEx Express 2 Day Shipping. In fact, most of our orders are shipped out on the same day the order is <strong>placed</strong>. We hope you'll agree that when it comes to benefits and the best value in the industry, no other medical alert system provider compares!
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footnotes Section */}
      <section className="alternative-section" style={{ background: '#f5f5f5', padding: '2rem 0' }}>
        <div className="container">
          <div className="table-footnote" style={{ marginTop: '0' }}>
            <p>*Pricing of Alert1 annual service plans. Monthly fee depends on system and options selected. Pricing is based on standard rates, temporary promotions may apply, offers subject to change.</p>
            <p>GreatCall/Lively website accessed on 12/29/2022. 10945 Vista Sorrento Pkwy Ste 120, San Diego, California 92130. Great Call / Lively mobile is a subsidiary of Best Buy.</p>
            <p>Medical alert comparisons and pricing are based on standard rates, temporary promotions may apply, offers subject to change. View our competitive advertising guidelines.</p>
            <p>If you would like to request any changes to the information provided here, contact <a href="mailto:marketing@alert1.com" style={{ color: '#0066cc', textDecoration: 'underline' }}>marketing@alert1.com</a></p>
            <p>*Alert1 and Modern Senior Magazine are wholly owned by ResponseLINK, LLC.</p>
            <p>Please note that for all comparisons a lack of a check mark indicates that the competitor criteria is not listed on the competitor's official website.</p>
          </div>
        </div>
      </section>

      {/* Best Buy Health Acquisitions Timeline Section */}
      <section className="alternative-section" style={{ background: 'white', padding: '2rem 2rem' }}>
        <div className="container">
          <h2 style={{ fontSize: '2.5rem', fontWeight: 700, color: '#333', marginBottom: '2rem', textAlign: 'center' }}>
            Best Buy's Health Acquisitions Timeline
          </h2>
          
          <div style={{ maxWidth: '900px', margin: '0 auto' }}>
            <div style={{ marginBottom: '2rem', padding: '1.5rem', background: '#f9f9f9', borderRadius: '8px' }}>
              <h3 style={{ fontSize: '1.5rem', fontWeight: 700, color: '#333', marginBottom: '0.75rem' }}>
                1. GreatCall Acquisition (Oct 1, 2018)
              </h3>
              <p style={{ fontSize: '1.1rem', fontWeight: 600, color: '#333', marginBottom: '0.5rem' }}>
                Purchase price: $792M
              </p>
              <p style={{ fontSize: '1rem', lineHeight: '1.6', color: '#333', marginBottom: '0.5rem' }}>
                One of the largest connected health product providers for seniors.
              </p>
              <p style={{ fontSize: '1rem', lineHeight: '1.6', color: '#333', marginBottom: '0.5rem' }}>
                <strong>Brands:</strong> Jitterbug, Lively, 5Star
              </p>
              <p style={{ fontSize: '1rem', lineHeight: '1.6', color: '#333' }}>
                <strong>Services:</strong> U.S.-based agents for family connections, concierge, emergency dispatch.
              </p>
            </div>

            <div style={{ marginBottom: '2rem', padding: '1.5rem', background: '#f9f9f9', borderRadius: '8px' }}>
              <h3 style={{ fontSize: '1.5rem', fontWeight: 700, color: '#333', marginBottom: '0.75rem' }}>
                2. CST Acquisition (May 9, 2019)
              </h3>
              <p style={{ fontSize: '1.1rem', fontWeight: 600, color: '#333', marginBottom: '0.5rem' }}>
                Purchase price: $125M
              </p>
              <p style={{ fontSize: '1rem', lineHeight: '1.6', color: '#333' }}>
                Also known as: CST Your Link to Life; Link to Life
              </p>
            </div>

            <div style={{ marginBottom: '2rem', padding: '1.5rem', background: '#f9f9f9', borderRadius: '8px' }}>
              <h3 style={{ fontSize: '1.5rem', fontWeight: 700, color: '#333', marginBottom: '0.75rem' }}>
                3. BioSensics Acquisition (Aug 7, 2019)
              </h3>
              <p style={{ fontSize: '1.1rem', fontWeight: 600, color: '#333', marginBottom: '0.5rem' }}>
                Purchase price: $20M
              </p>
              <p style={{ fontSize: '1rem', lineHeight: '1.6', color: '#333' }}>
                Predictive healthcare technology.
              </p>
            </div>

            <div style={{ marginTop: '2rem', padding: '1.5rem', background: '#f5f5f5', borderRadius: '8px' }}>
              <h3 style={{ fontSize: '1.3rem', fontWeight: 700, color: '#333', marginBottom: '1rem' }}>
                Consolidation Information
              </h3>
              <p style={{ fontSize: '1rem', lineHeight: '1.6', color: '#333', marginBottom: '0.75rem' }}>
                The brands and domains were consolidated under "Best Buy Health" in its Domestic segment.
              </p>
              <p style={{ fontSize: '1rem', lineHeight: '1.6', color: '#333', marginBottom: '0.5rem' }}>
                <strong>Consolidated Brands:</strong> Best Buy Health, CST, GreatCall, Lively, Current Health
              </p>
              <p style={{ fontSize: '1rem', lineHeight: '1.6', color: '#333' }}>
                <strong>Consolidated Domains:</strong> greatcall.com, currenthealth.com, lively.com
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CompareAlert1ToGreatCallPage;
